import { useEffect } from 'react';
import { useSendUserInput } from '../../../../../provider/socketContext';
import { useWelcomeStore } from '../../../../../store/sceneStore';

export const WelcomeText = () => {
	const welcome = useWelcomeStore();
	const sendUserInput = useSendUserInput();

	useEffect(() => {
		sendUserInput({
			type: 'user_input',
			text: 'welcome_text_request',
			value: {},
		});
	}, []);

	return (
		<div className='welcome_text'>
			{welcome.text !== null
				? welcome.text.split(';').map((it, i) => <div key={`x${i}`}>{it}</div>)
				: ''}
		</div>
	);
};
